import { TranslateService } from "projects/shared/src/lib/services/translate.service";


export class AgGridProjectRolesSettings {

  constructor(private translate: TranslateService) { }

  public agGridProjectRolesSettings = {
    rowModelType: 'infinite',
    //virtualPaging: true,
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: 'single',
    //rowDeselection: true,
    rowHeight: 55,
    enableRangeSelection: true,
    cacheBlockSize: 10000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 30,
    infiniteInitialRowCount: 0,
    columnDefs: [
      { field: 'name', headerName: `${this.translate.data["PROJECTROLESCOLUMNHEADER"]}`, cellStyle: { color: '#303f6f' }, sortable: true, filter: true },
      {
        headerName: `${this.translate.data["PROJECTSACTIONSCOLUMNHEADER"]}`,
        cellStyle: { color: '#303f6f' },
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          icon_list: 'perm_data_setting',
          icon_view: 'remove_red_eye',
          icon_person: 'person_add',
          icon_delete: 'delete',
          //routerLinkEditProject: (params: ICellRendererParams) => `/admin/manage-projects/${_.get(params, 'data.id')}/edit-project`
        }
      },
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 50,
      editable: false
    }
  }
}